/**
 * CurtainAdminParts.jsx - Reusable sub-components for CurtainAdminModal
 */

import React from 'react';
import { Check, AlertCircle, Trash2, Lock, MessageSquare } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const FeedbackToast = ({ feedback }) => {
  if (!feedback.message) return null;
  return (
    <div className={`mx-4 mt-3 px-3 py-2 rounded-lg flex items-center gap-2 text-sm ${
      feedback.type === 'success' ? 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30' 
               : 'bg-red-500/20 text-red-300 border border-red-500/30'
    }`}>
      {feedback.type === 'success' ? <Check size={16} /> : <AlertCircle size={16} />}
      {feedback.message}
    </div>
  );
};

export const ImageItem = ({ img, onRemove, isDefault }) => (
  <div className={`flex items-center gap-2 rounded-lg p-2 ${isDefault ? 'bg-slate-700/20 border border-slate-600/30' : 'bg-slate-700/30'}`}>
    <img src={img.url.startsWith('/') ? `${API_URL}${img.url}` : img.url} alt={img.name} 
      className="w-12 h-12 object-cover rounded bg-white flex-shrink-0"
      onError={(e) => { e.target.style.background = '#334155'; }} />
    <div className="flex-1 min-w-0">
      <p className="text-white text-sm font-medium truncate">{img.name}</p>
      {isDefault && <p className="text-slate-500 text-xs">Predeterminada</p>}
    </div>
    {isDefault ? (
      <Lock size={16} className="text-slate-500 flex-shrink-0" />
    ) : (
      <button onClick={() => onRemove(img.url)} className="p-2 text-red-400 hover:bg-red-500/20 rounded flex-shrink-0">
        <Trash2 size={16} />
      </button>
    )}
  </div>
);

export const QuoteItem = ({ q, onRemove, isDefault }) => (
  <div className={`flex items-start gap-2 rounded-lg p-2 ${isDefault ? 'bg-slate-700/20 border border-slate-600/30' : 'bg-slate-700/30'}`}>
    <MessageSquare size={16} className={`mt-1 flex-shrink-0 ${isDefault ? 'text-slate-500' : 'text-emerald-400'}`} />
    <div className="flex-1 min-w-0">
      <p className="text-white text-sm italic leading-snug">"{q.text}"</p>
      <p className={`text-xs mt-0.5 ${isDefault ? 'text-slate-500' : 'text-emerald-400'}`}>— {q.author}</p>
    </div>
    {isDefault ? (
      <Lock size={14} className="text-slate-500 flex-shrink-0 mt-1" />
    ) : (
      <button onClick={() => onRemove(q.text)} className="p-2 text-red-400 hover:bg-red-500/20 rounded flex-shrink-0">
        <Trash2 size={16} />
      </button>
    )}
  </div>
);
